export default __webpack_public_path__ + "static/media/loader.7f28ea12.png";